import { CanDeactivateFn } from '@angular/router';

import { CanLeaveComponent } from '@cure-common/interfaces';

export const CanLeaveGuard: CanDeactivateFn<CanLeaveComponent> = (component) => {
  return component.canLeave ? component.canLeave() : true;
};
